var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEye = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 4.21924C5.83325 4.21924 2.27492 6.8109 0.833252 10.4692C2.27492 14.1276 5.83325 16.7192 9.99992 16.7192C14.1666 16.7192 17.7249 14.1276 19.1666 10.4692C17.7249 6.8109 14.1666 4.21924 9.99992 4.21924ZM9.99992 14.6359C7.69992 14.6359 5.83325 12.7692 5.83325 10.4692C5.83325 8.16924 7.69992 6.30257 9.99992 6.30257C12.2999 6.30257 14.1666 8.16924 14.1666 10.4692C14.1666 12.7692 12.2999 14.6359 9.99992 14.6359ZM9.99992 7.96924C8.61658 7.96924 7.49992 9.08591 7.49992 10.4692C7.49992 11.8526 8.61658 12.9692 9.99992 12.9692C11.3833 12.9692 12.4999 11.8526 12.4999 10.4692C12.4999 9.08591 11.3833 7.96924 9.99992 7.96924Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEye);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eye.74a0a7addaa5603950d5b505134ee0b0.svg";